import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerFreightStoragesManagersModule } from './container-freight-storages-managers';
import { VoyagesModule } from './voyages';
import { RoutesModule } from './routes';
import { ContainersModule } from './containers';
import { ContainerSealsModule } from './container-seals';
import { MasterBillsModule } from './master-bills';
import { LclEntitiesModule } from './lcl-entities';
import { PackingListsModule } from './packing-lists';
import { PackingListItemsModule } from './packing-list-items';
import { LclPackagesModule } from './lcl-packages';
import {
  LclAdditionalProductAttachComponent,
  LclDestinationWarehouseComponent,
  LclOriginWarehouseComponent,
  LclShipmentDetailsComponent,
  LclShipmentTrackingStateComponent,
} from '@app/modules/lcl-shipping/components';
import { TranslateModule } from '@ngx-translate/core';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import {
  LclCardComponent,
  LclCreateQuoteComponent,
  LclCreateQuoteExternalComponent,
  LclCreateQuoteFromToComponent,
  LclCreateQuoteFromToUpdatedComponent,
  LclCreateQuotePackagesComponent,
  LclDashboardManualQuoteCardComponent,
  LclDashboardPlaceholderComponent,
  LclDashboardQuoteCardComponent,
  LclDashboardShipmentCardComponent,
  LclEditAdditionalOptionsComponent,
  LclEditBookingComponent,
  LclEditIncotermsComponent,
  LclEditPackageComponent,
  LclEmptyListPlaceholderComponent,
  LclEntityEditComponent,
  LclExternalQuoteNotificationComponent,
  LclFooterComponent,
  LclHazardDisclaimerComponent,
  LclHeaderDetailedInfoComponent,
  LclIncotermsComponent,
  LclIncotermsItemsComponent,
  LclPackagesViewComponent,
  LclPackagesViewRowComponent,
  LclPaymentCardComponent,
  LclPortDropdownComponent,
  LclQuoteTotalCostComponent,
  LclResultsFilesComponent,
  LclRouteWarningComponent,
  LclSelectVoyageComponent,
  LclShipmentContactsComponent,
  LclShipmentTotalsInfoComponent,
  LclShipmentVoyageInfoComponent,
  LclShippingPackageEditComponent,
  LclShippingPackageEditOldComponent,
  LclShippingPackageItemViewComponent,
  MobileLclCardComponent,
  MobileLclManualQuoteCardComponent,
  ShipmentDocumentsComponent,
  ViewChargesComponent,
  ViewChargesMobileComponent,
} from './components';
import { RouterModule } from '@angular/router';
import { MutualModule } from '@shared/mutual/mutual.module';

import { IconsModule } from '@shared/icons/icons.module';
import { AddressModule } from '@shared/address/address.module';
import { EntityMutualModule } from '@shared/entity-mutual/entity-mutual.module';
import { MissingFieldsModule } from '@shared/missing-fields/missing-fields.module';
import { EntityModule } from '@shared/entity/entity.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { DocumentModule } from '@shared/document/document.module';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { LclContainerService } from './services';
import { LclShipmentProductBoxComponent } from './components/lcl-shipment-product-box/lcl-shipment-product-box.component';
import { CompanyModule } from '@app/modules/company/company.module';
import { InputPhoneModule } from '@shared/input-phone/input-phone.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { NgxsModule } from '@ngxs/store';
import { LCLShippingState } from '@app/modules/lcl-shipping/state';
import { IsfMutualModule } from '@shared/isf-mutual/isf-mutual.module';
import { EsMutualModule } from '@shared/es-mutual/es-mutual.module';
import { MarineInsuranceSharedModule } from '@shared/marine-insurance-shared';
import { QuoteListComponent, QuoteManualListComponent } from '@shared/lcl-mutual/quotes/components';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NgxPaginationModule } from 'ngx-pagination';
import { RecaptchaModule } from 'ng-recaptcha';
import { CompanySharedModule } from '@shared/company-shared/company-shared.module';
import { PaymentSharedModule } from '@shared/payment-shared';

@NgModule({
  declarations: [
    LclPackagesViewComponent,
    LclDestinationWarehouseComponent,
    LclOriginWarehouseComponent,
    LclShipmentDetailsComponent,
    LclShipmentTrackingStateComponent,
    LclEmptyListPlaceholderComponent,
    LclDashboardPlaceholderComponent,
    MobileLclCardComponent,
    MobileLclManualQuoteCardComponent,
    LclDashboardShipmentCardComponent,
    LclDashboardQuoteCardComponent,
    LclDashboardManualQuoteCardComponent,
    LclShipmentTotalsInfoComponent,
    LclQuoteTotalCostComponent,
    LclHeaderDetailedInfoComponent,
    LclShipmentVoyageInfoComponent,
    LclIncotermsComponent,
    LclEditIncotermsComponent,
    LclIncotermsItemsComponent,

    LclCardComponent,
    LclEntityEditComponent,
    LclShipmentContactsComponent,
    LclEditPackageComponent,
    LclPackagesViewRowComponent,
    LclShippingPackageEditComponent,
    ShipmentDocumentsComponent,
    LclResultsFilesComponent,
    ViewChargesComponent,
    ViewChargesMobileComponent,

    LclShipmentProductBoxComponent,
    LclAdditionalProductAttachComponent,

    LclSelectVoyageComponent,
    LclHazardDisclaimerComponent,
    LclFooterComponent,
    LclPaymentCardComponent,
    LclEditBookingComponent,
    LclEditAdditionalOptionsComponent,

    LclCreateQuoteFromToComponent,
    LclCreateQuotePackagesComponent,
    LclCreateQuoteComponent,

    LclPortDropdownComponent,
    LclCreateQuoteFromToUpdatedComponent,
    LclRouteWarningComponent,
    LclExternalQuoteNotificationComponent,
    LclShippingPackageItemViewComponent,
    LclShippingPackageEditOldComponent,
    LclCreateQuoteExternalComponent,

    QuoteListComponent,
    QuoteManualListComponent,
  ],
  imports: [
    AccordionModule.forRoot(),
    AddressModule,
    BsDropdownModule.forRoot(),
    CommonModule,
    CompanyModule,
    ContainerFreightStoragesManagersModule,
    ContainerSealsModule,
    ContainersModule,
    FlexLayoutModule,
    InputPhoneModule,
    LclEntitiesModule,
    LclPackagesModule,
    MasterBillsModule,
    PackingListItemsModule,
    PackingListsModule,
    PipesSharedModule,
    RouterModule,
    RoutesModule,
    TranslateModule,
    VoyagesModule,
    MutualModule,
    IconsModule,
    AddressModule,
    EntityMutualModule,
    MissingFieldsModule,
    EntityModule,
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    DocumentModule,
    CustomModalModule,
    FormWrapperModule,
    IsfMutualModule,
    EsMutualModule,
    NgxsModule.forFeature([LCLShippingState]), // TODO move LCLShippingState later to mutual
    MarineInsuranceSharedModule,
    NzPopoverModule,
    NgxPaginationModule,
    RecaptchaModule,
    CompanySharedModule,
    PaymentSharedModule,
  ],
  exports: [
    ContainerFreightStoragesManagersModule,
    VoyagesModule,
    ContainersModule,
    RoutesModule,
    ContainerSealsModule,
    MasterBillsModule,
    LclEntitiesModule,
    PackingListsModule,
    PackingListItemsModule,
    LclPackagesModule,

    LclPackagesViewComponent,
    LclDestinationWarehouseComponent,
    LclOriginWarehouseComponent,
    LclShipmentDetailsComponent,
    LclShipmentTrackingStateComponent,
    LclEmptyListPlaceholderComponent,
    LclDashboardPlaceholderComponent,
    MobileLclCardComponent,
    MobileLclManualQuoteCardComponent,
    LclDashboardShipmentCardComponent,
    LclDashboardQuoteCardComponent,
    LclDashboardManualQuoteCardComponent,
    LclShipmentTotalsInfoComponent,
    LclQuoteTotalCostComponent,
    LclHeaderDetailedInfoComponent,
    LclShipmentVoyageInfoComponent,

    LclIncotermsComponent,
    LclEditIncotermsComponent,
    LclIncotermsItemsComponent,

    LclCardComponent,
    LclEntityEditComponent,
    LclShipmentContactsComponent,
    LclEditPackageComponent,
    LclPackagesViewRowComponent,
    LclShippingPackageEditComponent,
    ShipmentDocumentsComponent,
    LclResultsFilesComponent,
    ViewChargesComponent,
    ViewChargesMobileComponent,

    LclShipmentProductBoxComponent,
    LclAdditionalProductAttachComponent,

    LclSelectVoyageComponent,
    LclHazardDisclaimerComponent,
    LclFooterComponent,
    LclPaymentCardComponent,
    LclEditBookingComponent,
    LclEditAdditionalOptionsComponent,

    LclCreateQuoteFromToComponent,
    LclCreateQuotePackagesComponent,
    LclCreateQuoteComponent,

    LclPortDropdownComponent,
    LclCreateQuoteFromToUpdatedComponent,
    LclRouteWarningComponent,
    LclExternalQuoteNotificationComponent,
    LclShippingPackageItemViewComponent,
    LclShippingPackageEditOldComponent,
    LclCreateQuoteExternalComponent,

    QuoteListComponent,
    QuoteManualListComponent,
  ],
  providers: [LclContainerService],
})
export class LclMutualModule {}
